import React from "react";
import {
  GiveawayActive,
  GiveawayArchieve,
  FormattedPrizeRange,
} from "../../../../types";
import styles from "../../../GiveawayDetails/GiveawayDetails.module.css";
import { NFTAnimation } from "../NFTAnimation/NFTAnimation";
import dreamcoinLogo from "/DC_coin.svg";
import CharacterLogo from "/character-circle-gold.svg";
import firstPlace from "/1place.svg";
import secondPlace from "/2place.svg";
import thirdPlace from "/3place.svg";

interface GiveawayPrizesPropsActive {
  giveaway: GiveawayActive | GiveawayArchieve;
  formattedPrizes: FormattedPrizeRange[];
  openNFTDetails: (detail: string) => void;
  formatNumber: (num: number) => string;
}

const GiveawayPrizesActive: React.FC<GiveawayPrizesPropsActive> = ({
  giveaway,
  formattedPrizes,
  openNFTDetails,
  formatNumber,
}) => {
  return (
    <div className={styles.placesContainer}>
      <div className={styles.placeInfo}>
        <div className={styles.placeInfoPlace}>Место</div>
        <div className={styles.placeInfoPrize}>Награда</div>
      </div>
      {formattedPrizes.length > 0 && (
        <>
          <div
            className={styles.place}
            onClick={() =>
              formattedPrizes[0].type === "TelegramNFT"
                ? openNFTDetails(formattedPrizes[0].urls!.detail)
                : undefined
            }
          >
            <div className={styles.placePlace}>
              <img src={firstPlace} alt="" />
            </div>
            <div className={styles.placePrize}>
              {formattedPrizes[0].type === "TelegramNFT" &&
              formattedPrizes[0].urls ? (
                <div className={styles.nftPrize}>
                  <div className={styles.nftInfo}>
                    <div className={styles.nftName}>
                      {formattedPrizes[0].name}
                    </div>
                    <div className={styles.nftDescription}>
                      #{formattedPrizes[0].number}
                    </div>
                  </div>
                  <NFTAnimation
                    urls={formattedPrizes[0].urls}
                    status={giveaway.status}
                  />
                </div>
              ) : (
                <>
                  <div>
                    {formattedPrizes[0].type === "DC"
                      ? formatNumber(formattedPrizes[0].amount)
                      : "Легендарный"}
                  </div>
                  <img
                    src={
                      formattedPrizes[0].type === "DC"
                        ? dreamcoinLogo
                        : CharacterLogo
                    }
                    alt=""
                  />
                </>
              )}
            </div>
          </div>
          <div
            className={styles.place}
            onClick={() =>
              formattedPrizes[1].type === "TelegramNFT"
                ? openNFTDetails(formattedPrizes[1].urls!.detail)
                : undefined
            }
          >
            <div className={styles.placePlace}>
              <img src={secondPlace} alt="" />
            </div>
            <div className={styles.placePrize}>
              {formattedPrizes[1].type === "TelegramNFT" &&
              formattedPrizes[1].urls ? (
                <div className={styles.nftPrize}>
                  <div className={styles.nftInfo}>
                    <div className={styles.nftName}>
                      {formattedPrizes[1].name}
                    </div>
                    <div className={styles.nftDescription}>
                      #{formattedPrizes[1].number}
                    </div>
                  </div>
                  <NFTAnimation
                    urls={formattedPrizes[1].urls}
                    status={giveaway.status}
                  />
                </div>
              ) : (
                <>
                  <div>
                    {formattedPrizes[1].type === "DC"
                      ? formatNumber(formattedPrizes[1].amount)
                      : "Легендарный"}
                  </div>
                  <img
                    src={
                      formattedPrizes[1].type === "DC"
                        ? dreamcoinLogo
                        : CharacterLogo
                    }
                    alt=""
                  />
                </>
              )}
            </div>
          </div>
          <div
            className={styles.place}
            onClick={() =>
              formattedPrizes[2].type === "TelegramNFT"
                ? openNFTDetails(formattedPrizes[2].urls!.detail)
                : undefined
            }
          >
            <div className={styles.placePlace}>
              <img src={thirdPlace} alt="" />
            </div>
            <div className={styles.placePrize}>
              {formattedPrizes[2].type === "TelegramNFT" &&
              formattedPrizes[2].urls ? (
                <div className={styles.nftPrize}>
                  <div className={styles.nftInfo}>
                    <div className={styles.nftName}>
                      {formattedPrizes[2].name}
                    </div>
                    <div className={styles.nftDescription}>
                      #{formattedPrizes[2].number}
                    </div>
                  </div>
                  <NFTAnimation
                    urls={formattedPrizes[2].urls}
                    status={giveaway.status}
                  />
                </div>
              ) : (
                <>
                  <div>
                    {formattedPrizes[2].type === "DC"
                      ? formatNumber(formattedPrizes[2].amount)
                      : "Легендарный"}
                  </div>
                  <img
                    src={
                      formattedPrizes[2].type === "DC"
                        ? dreamcoinLogo
                        : CharacterLogo
                    }
                    alt=""
                  />
                </>
              )}
            </div>
          </div>
          {formattedPrizes.map((prize: FormattedPrizeRange, index: number) =>
            typeof prize.place === "string" ? (
              <div className={styles.place} key={index}>
                <div className={styles.placePlace}>{prize.place}</div>
                <div className={styles.placePrize}>
                  <div>
                    {prize.type === "DC"
                      ? formatNumber(prize.amount)
                      : "Легендарный"}
                  </div>
                  <img
                    src={prize.type === "DC" ? dreamcoinLogo : CharacterLogo}
                    alt=""
                  />
                </div>
              </div>
            ) : null
          )}
        </>
      )}
    </div>
  );
};

export default GiveawayPrizesActive;
